//TODO: Define e
export function barChartPlotter(e: any): void {
    const ctx = e.drawingContext
    const points = e.points
    const y_bottom = e.dygraph.toDomYCoord(0)

    let xDiff = 100
    if (points.length > 1) xDiff = points[1].canvasx - points[0].canvasx
    const bar_width = (2 / 3) * xDiff
    ctx.fillStyle = e.color
    for (let i = 0; i < points.length; i++) {
        const p = points[i]
        const center_x = p.canvasx // center of the bar

        ctx.fillRect(center_x - bar_width / 2, p.canvasy, bar_width, y_bottom - p.canvasy)
        ctx.strokeRect(center_x - bar_width / 2, p.canvasy, bar_width, y_bottom - p.canvasy)
    }
}
